import { createContext } from 'react';
import { WhoAmIQuery } from '../generated/graphql';

const init: WhoAmIQuery['whoAmI'] = {
  id: '',
  email: '',
  name: '',
  isBusinessAccountOwner: false,
  isConfirmed: false,
  level: null,
  type: '',
};

export default createContext<[WhoAmIQuery['whoAmI'], (user: WhoAmIQuery['whoAmI']) => void]>([
  init,
  () => ({}),
]);
